import React, { useEffect, useState } from "react";
import { AiFillDelete } from "react-icons/ai";
import { FaEdit } from "react-icons/fa";
import { Link } from "react-router-dom";
import LoadingData from "../../Common/LoadingData";



const AllCourses = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/courses`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const bbb = data.msg.map((b, index) => b.courses);
        let arr = [];
        bbb.map((v, index) => arr.push(...v));
        setData(arr);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleDelete = (id) => {
    fetch(`${process.env.REACT_APP_BASE_URL}/admin/course/${id}`, {
      method: "DELETE",
      credentials: "include",
    })
      .then((data) => data.json())
      .then((res) => {
        if (res.status === "success") {
          window.location.reload();
        } else {
          alert(res.msg);
        }
      });
  };


  return (
    loading ? <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
    <div className="lds-dual-ring"></div>
  </div> :
    <section>
      <div className="container">
        <div className="row">
          <div className="col-md-11 m-auto">
            <div className="add-page">
              <table>
                <caption>All Courses</caption>
                <thead>
                  <tr>
                    <th>Course Name</th>
                    <th>Price</th>
                    <th>Level</th>
                    <th>Delete</th>
                    <th>Edit</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => (
                    <tr key={index}>
                      <td>{item.name}</td>
                      <td>{item.price}</td>
                      <td>{item.level}</td>
                      <td>
                        <span
                          onClick={() => handleDelete(item._id)}
                          className="del"
                        >
                          <AiFillDelete />
                        </span>
                      </td>
                      <td>
                        <Link to={`/dashboard/coursesedit/${item._id}`}>
                          <span className="edit">
                            <FaEdit />
                          </span>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AllCourses;
